var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification2Fill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 25H2.5V22.5H3.75V13.7892C3.75 7.55435 8.7868 2.5 15 2.5C21.2132 2.5 26.25 7.55435 26.25 13.7892V22.5H27.5V25ZM11.875 26.25H18.125C18.125 27.9759 16.7259 29.375 15 29.375C13.2741 29.375 11.875 27.9759 11.875 26.25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification2Fill);
export default __webpack_public_path__ + "static/media/notification-2-fill.f0061860e7c2b825f77f4694e8670c11.svg";
export { ForwardRef as ReactComponent };